import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  const checkoutLink = 'https://pay.hotmart.com/Q104948761S?checkoutMode=10';
  return <section className="py-20 px-4 bg-blue-900 text-white text-center" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <h2 className="text-2xl md:text-3xl font-medium leading-relaxed mb-10 text-blue-100" data-id="element-61">
          Se vuoi aiutare i bambini a sviluppare calma, concentrazione ed
          equilibrio emotivo attraverso attività divertenti e consapevoli,
          questo Mega-Pack può diventare uno strumento davvero prezioso.
        </h2>

        <div className="flex justify-center mb-8" data-id="element-62">
          <CountdownTimer variant="dark" size="lg" data-id="element-63" />
        </div>

        <button onClick={() => window.open(checkoutLink, '_blank')} className="bg-green-600 hover:bg-green-700 text-white font-black text-xl md:text-2xl py-6 px-10 rounded-full shadow-2xl transition-all transform hover:-translate-y-1 animate-pulse w-full md:w-auto" data-id="element-64">
          ACQUISTA ORA - 15,99 €
        </button>
        <p className="mt-6 text-blue-300 text-sm" data-id="element-65">
          Accesso immediato • Garanzia 7 giorni • Pagamento sicuro
        </p>
      </div>
    </section>;
}